export default __webpack_public_path__ + "static/media/engagement-rate-growth.68c220e4.png";